module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "detail-list"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-id-card-o fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("ID")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.id))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-key fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("IID")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.iid))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-hourglass-half fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("App Install (Updated)")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.updated))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-hourglass fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("App Login (Updated)")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.loginupdate))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-cogs fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("Manufacturer")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.manufacturer))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-barcode fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("Model")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.model))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-exchange fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("App Version")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.version))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-exchange fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("Debug Version")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.vdevice))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-mobile-phone fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("Google Play Services")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.gsmMajor) + _vm._s(_vm.device.gsmMinor))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-mobile-phone fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("gsmMajor")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.gsmMajor))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-mobile-phone fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("gsmMinor")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.gsmMinor))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-google fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("PlayStore Major")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.playstoreMajor))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-google fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("PlayStore Minor")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.playstoreMinor))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-location-arrow fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("gapiAviablity")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.gapiAviablity))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-facebook-square fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("Facebook")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.facebook))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-facebook-square fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("Messenger")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.messenger))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-address-card fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("Name")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.name))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-toggle-up fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("Major")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.major))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-toggle-down fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("Minor")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.minor))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-code-fork fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("Patch")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.patch))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-id-card-o fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("SDK")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.sdk))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-thermometer-2 fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("TotalMem")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.totalMem))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-th-list fa-cus-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "label-list"
  }, [_vm._v("thresholdMem")]), _c('span', {
    staticClass: "result-list"
  }, [_vm._v(_vm._s(_vm.device.thresholdMem))])])])]), _vm._v(" ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f88c7a16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/DeviceView.vue
// module id = 176
// module chunks = 2